import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Drawer, useTheme, useMediaQuery, Box, IconButton, Typography, Divider } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { between } from '@ui/style/style';
import CustomDialog from '.';
const ConfirmationDialog = ({ open, onClose, title, children, actions, maxWidth = 'sm' }) => {
    const theme = useTheme();
    const isSmallScreen = useMediaQuery(theme.breakpoints.down('lg'));
    if (!isSmallScreen) {
        return (_jsx(CustomDialog, { open: open, onClose: onClose, title: title, children: children, actions: actions, maxWidth: maxWidth }));
    }
    return (_jsxs(Drawer, { anchor: 'bottom', open: open, onClose: onClose, PaperProps: {
            sx: {
                p: 2,
                borderTopLeftRadius: 16,
                borderTopRightRadius: 16
            }
        }, children: [title && (_jsxs(Box, { sx: { ...between, mb: 2 }, children: [_jsx(Typography, { variant: 'h6', children: title }), _jsx(IconButton, { onClick: onClose, size: 'small', children: _jsx(CloseIcon, {}) })] })), _jsx(Box, { sx: { mb: 2 }, children: children }), actions && (_jsxs(_Fragment, { children: [_jsx(Divider, { sx: { my: 1 } }), _jsx(Box, { sx: { display: 'flex', justifyContent: 'flex-end', gap: 1 }, children: actions })] }))] }));
};
export default ConfirmationDialog;
